import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./modules.module.css";

const Modules = ({ data }) => {
  const modules = Array.isArray(data?.modules) ? data.modules : [];
  const [showAll, setShowAll] = useState(false);

  if (modules.length === 0) return null;

  const visibleModules =
    modules.length > 5 && !showAll ? modules.slice(0, 5) : modules;

  return (
    <section className={styles.module}>
      <div className={styles.section}>
        <div className={styles.moduleTitle}>
          <h5>Modules/Forms</h5>
        </div>

        <div className={styles.modulesList}>
          {visibleModules.map((module) => (
            <Link
              key={module.standardId}
              to={`/document/${module.standardId}`}
              className={styles.moduleItem}
            >
              <p className={styles.moduleName}>{module.title}</p>

              <p className={styles.moduleCategory}>
                {module.referenceNumber} — Issue {module.issue}
              </p>
            </Link>
          ))}
        </div>

        {modules.length > 5 && (
          <button
            className={styles.moreBtn}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Less" : "More"}
          </button>
        )}
      </div>
    </section>
  );
};

export default Modules;
